import { Store, StoreConfig } from "@datorama/akita";
import { injectable } from "tsyringe";

import ReviewsProductInfoEntity from "../entities/ReviewsProductInfoEntity";

export type ReviewsProductInfoState = {
    productInfo: ReviewsProductInfoEntity | null;
};

export function createInitialState(): ReviewsProductInfoState {
    return {
        productInfo: null,
    };
}

@injectable()
@StoreConfig({ name: "reviews_product_info" })
class ReviewsProductInfoStore extends Store<ReviewsProductInfoState> {
    constructor() {
        super(createInitialState());
    }
}

export default ReviewsProductInfoStore;
